import { useMutation } from '@apollo/client'
import { EditQuestionnaireSurveys, EditQuestionnaireSurveysVariables } from '../../types'
import { EDIT_QUESTIONNAIRE_SURVEYS } from './operations'

export const useEditQuestionnaire = () =>
  useMutation<EditQuestionnaireSurveys, EditQuestionnaireSurveysVariables>(
    EDIT_QUESTIONNAIRE_SURVEYS
  )
